var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43288 15C5.86608 15.006 5.32983 14.4206 4.95829 14.0029C4.08583 12.9309 4.56728 11.7429 4.75909 10.4425L0.779694 10.4425C0.241734 10.4385 -0.0340267 10.034 0.00335932 9.4874L1.11759 2.58332C1.37008 1.70044 2.35152 0.923231 3.38609 0.812844L10.7472 0.812845C11.1827 0.818525 11.5089 1.12761 11.5431 1.60873L11.5431 9.64659C11.5374 10.082 11.2283 10.4083 10.7472 10.4424L8.91719 10.4424L7.10668 14.501C7.00599 14.72 6.74205 14.995 6.43288 15ZM13.0948 10.6016C12.7885 10.5977 12.5443 10.386 12.5187 10.044L12.5187 1.17026C12.5231 0.870538 12.7715 0.637071 13.0948 0.613619L15.4229 0.613619C15.7183 0.617672 15.9722 0.841553 16 1.17026L16 10.044C15.9958 10.3536 15.7603 10.5782 15.4229 10.6016L13.0948 10.6016Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.3069681a5116cdfc6f246f421bbb9f1e.svg";
export { ForwardRef as ReactComponent };